var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6672 0C16.6538 0 15.7139 0.501072 15.1903 1.37262L0.393234 26.0765C-0.130374 26.9504 -0.131781 28.0269 0.393234 28.9001C0.874943 29.7012 1.75981 30.2907 2.77537 30.2882H32.5588C33.574 30.2882 34.4592 29.7012 34.9409 28.9001C35.466 28.0269 35.4642 26.9504 34.9409 26.0765L20.1439 1.37262C19.6206 0.501108 18.6805 0 17.667 0H17.6672ZM17.6672 2.01904C17.9468 2.01904 18.2845 2.20671 18.4088 2.41341L33.2058 27.1173C33.3298 27.3243 33.3305 27.6518 33.2058 27.8588C33.0382 28.1377 32.8396 28.2698 32.559 28.2691H2.77553C2.49524 28.2694 2.29629 28.1377 2.12868 27.8588C2.00438 27.6518 2.00473 27.3247 2.12868 27.1173L16.9257 2.41341C17.05 2.20671 17.3874 2.01904 17.6673 2.01904H17.6672ZM17.6672 8.07659C17.1094 8.07659 16.6577 8.52872 16.6577 9.08611V20.1918C16.6577 20.7496 17.1098 21.2013 17.6672 21.2013C18.2249 21.2013 18.6767 20.7492 18.6767 20.1918V9.08611C18.6767 8.52835 18.2246 8.07659 17.6672 8.07659ZM17.6672 23.2207C16.8309 23.2207 16.1527 23.8989 16.1527 24.7352C16.1527 25.5715 16.8305 26.2497 17.6672 26.2497C18.5035 26.2497 19.1817 25.5719 19.1817 24.7352C19.1817 23.8989 18.5035 23.2207 17.6672 23.2207Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0b184ea80b8f1c86913cf037d266716f.svg";
export { ForwardRef as ReactComponent };